// extracted by mini-css-extract-plugin
module.exports = {"accHead":"Accordion_accHead__JAmb7","titleAccordion":"Accordion_titleAccordion__2L1nt","activeSecondary":"Accordion_activeSecondary__uz3V_"};